import { render, staticRenderFns } from "./AttributeField.vue?vue&type=template&id=82bb6b4c&"
import script from "./AttributeField.vue?vue&type=script&lang=js&"
export * from "./AttributeField.vue?vue&type=script&lang=js&"
import style0 from "./AttributeField.vue?vue&type=style&index=0&id=82bb6b4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports